import React, { useEffect, useState } from "react";
import Loader from "examples/Loader";
import PageLayout from "examples/LayoutContainers/PageLayout";
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import breakpoints from "assets/theme/base/breakpoints";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { useAgencyInfo } from "context/agency";
import { useAppServices } from "hook/services";
import { useLocation } from "react-router-dom";
import dragImage from "../../../assets/images/drag.png";

const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);
  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);
  return result;
};

const index = () => {
  const { values } = breakpoints;
  const [loader, setloader] = useState(true);
  const [list, setList] = useState([]);
  const [agency] = useAgencyInfo();
  const AppService = useAppServices();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const type = queryParams.get("type");

  const onLoad = async () => {
    const queryParams = [`agency_id=${agency._id}`, `tags=business`];
    if (type && type !== "all") {
      queryParams.push(`plan_type=${type}`);
    }
    const queryString = queryParams.join("&");
    const { response } = await AppService.accounts.GetAccountsForAgency({
      query: queryString,
      toaster: false,
    });
    if (response) {
      setList(response?.data || []);
      setloader(false);
    } else {
      setList([]);
      setloader(false);
    }
  };

  useEffect(() => {
    onLoad();
  }, []);

  useEffect(() => {
    let Sorted = list?.sort((a, b) => a.order - b.order);
    if (type === "premium") {
      Sorted = list?.sort((a, b) => (a.premium_order ?? 0) - (b.premium_order ?? 0));
    } else if (type === "free") {
      Sorted = list?.sort((a, b) => (a.free_order ?? 0) - (b.free_order ?? 0));
    }
    setCurrentItems(Sorted);
  }, [list]);
  const [currentItems, setCurrentItems] = useState([]);

  const onDragEnd = async (result) => {
    if (!result.destination) return;
    const reordered = reorder(currentItems, result.source.index, result.destination.index);
    setCurrentItems(reordered);

    const reorderedPayload = reordered.map((item, index) => ({
      _id: item._id,
      order: index,
    }));

    const payload = {
      type,
      reorderItems: reorderedPayload,
    };

    await AppService.accounts.ReOrderBusiness({
      payload,
    });
  };

  const tableTHStyles = {
    fontFamily: "Poppins",
    fontWeight: 600,
  };

  return loader ? (
    <Loader />
  ) : (
    <PageLayout>
      <SoftBox alignItems="center">
        <div
          className="d-flex w-100 align-items-center"
          style={{ justifyContent: "space-between" }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            <SoftTypography
              variant={window.innerWidth < values.sm ? "h3" : "h2"}
              textTransform="capitalize"
              fontWeight="600"
            >
              Reorder Business
            </SoftTypography>
          </div>
        </div>

        <table className="table w-100" style={{ width: "100%", borderCollapse: "collapse" }}>
          <thead>
            <tr style={{ background: "#F7F7F7", borderRadius: "18px" }}>
              <th
                className="p-20-px text-left"
                style={{
                  ...tableTHStyles,
                  borderBottomLeftRadius: "18px",
                  borderTopLeftRadius: "18px",
                }}
              >
                Drag
              </th>
              <th
                className="p-20-px text-left"
                style={{
                  ...tableTHStyles,
                  borderBottomLeftRadius: "18px",
                  borderTopLeftRadius: "18px",
                }}
              >
                Listing Title
              </th>
              <th className="p-20-px text-left" style={tableTHStyles}>
                Type
              </th>
              <th className="p-20-px text-left" style={tableTHStyles}>
                Status
              </th>
              <th className="p-20-px text-left" style={tableTHStyles}>
                Address
              </th>
            </tr>
          </thead>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="droppable" direction="vertical">
              {(provided) => (
                <tbody {...provided.droppableProps} ref={provided.innerRef}>
                  {currentItems?.length > 0 ? (
                    currentItems?.map((item, index) => (
                      <Draggable key={item.id} draggableId={String(item.id)} index={index}>
                        {(provided) => (
                          <tr
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={{
                              ...provided.draggableProps.style,
                              borderBottom: "1px solid #DDDDDD",
                              background: "#fff",
                            }}
                          >
                            <td className="p-20-px">
                              <div
                                style={{
                                  width: 50,
                                  height: 50,
                                  backgroundImage: `url(${dragImage})`,
                                  backgroundSize: "cover",
                                  backgroundBlendMode: "invert",
                                  display:"flex",
                                  justifyContent:"center",
                                  alignItems:"center"
                                }}
                              ></div>
                            </td>
                            <td className="p-20-px" style={{ display: "flex", gap: "20px" }}>
                              {item?.profile_image && (
                                <div
                                  style={{
                                    width: "150px",
                                    height: "100px",
                                    overflow: "hidden",
                                    borderRadius: "12px",
                                  }}
                                >
                                  <img
                                    style={{
                                      width: "100%",
                                      height: "100%",
                                      objectFit: "cover",
                                    }}
                                    src={item?.profile_image}
                                  />
                                </div>
                              )}
                              <div>
                                <h4
                                  style={{
                                    fontWeight: 600,
                                  }}
                                >
                                  {item.first_name}
                                </h4>
                                <p
                                  style={{
                                    fontWeight: 400,
                                    fontSize: "15px",
                                  }}
                                >
                                  {item?.address}
                                </p>
                              </div>
                            </td>
                            <td className="p-20-px">
                              <span>
                                {item?.plan_type === "premium" ? item?.plan_type : "Free"}
                              </span>
                            </td>
                            <td className="p-20-px" style={{ textTransform: "capitalize" }}>
                              <span
                                className={`status-pill ${
                                  item?.status === "active"
                                    ? "active"
                                    : item?.status === "pending"
                                    ? "pending"
                                    : item?.status === "published"
                                    ? "published"
                                    : item?.status === "processing"
                                    ? "processing"
                                    : "default"
                                }`}
                              >
                                {item?.status}
                              </span>
                            </td>
                            <td className="p-20-px">{item?.address || ""}</td>
                          </tr>
                        )}
                      </Draggable>
                    ))
                  ) : (
                    <tr>
                      <td colSpan={8} className="text-center">
                        No accounts found
                      </td>
                    </tr>
                  )}
                  {provided.placeholder}
                </tbody>
              )}
            </Droppable>
          </DragDropContext>
        </table>
      </SoftBox>
    </PageLayout>
  );
};

export default index;
